<div>
  <h3
    *ngIf="!hiddePercent && (((data.status === 4 || data.status === 12) && data.contributed > 0) || (data.status === 15 && data.reserved > 0))"
    class="font-sansMedium text-eggplant-100/[0.25] children:text-center children:top-[-12px] children:!-ml-24 relative pb-8 w-full">
    <span class="absolute text-m" [ngStyle]="{ left: leftPercent + '%' }" [ngClass]="{
        '!leading-none w-fit whitespace-nowrap w-[54px]': minExceeded,
        'w-48': !minExceeded
      }">{{ percent | number:'1.0-1':'es' }}%</span>
  </h3>

  <div
    *ngIf="(((data.status === 4 || data.status === 12) && data.contributed > 0) || (data.status === 15 && data.reserved > 0))"
    class="bar-grap-container" [ngClass]="{
    'h-12': size === 's',
    'h-16': size === 'm'
  }">
    <div class="relative w-full bg-[#EAE7E9] rounded-[40px]" [ngClass]="{
        'h-12': size === 's',
        'h-16': size === 'm',
        'bg-success/[0.10]': minExceeded,
        'bg-[#EAE7E9]': !minExceeded
      }">
      <div class="absolute z-10" [ngClass]="{
        'rounded-l-[40px] rounded-r-none': (barWidth + barWidthReserved) < 85,
        'rounded-[40px]': (barWidth + barWidthReserved) >= 85,
        'h-12': size === 's',
        'h-16': size === 'm'
        }"
        [ngStyle]="{ width: (barWidth + barWidthReserved) + '%', 'max-width': '100%', 'min-width': '2.5%', 'background': 'linear-gradient(90deg, #FF5C2F ' + barWidth + '%, #FFD43C 100%)' }">
      </div>
    </div>
  </div>

  <div *ngIf="!hiddeObjetive" class="flex justify-end">
    <div [ngClass]="{'children:!text-2xl' : (data.contributed === 0 && !data.contributed_intention) }"
      class="flex gap-4 w-full justify-between">
      <p *ngIf="data.total_official && data.total_official > 0" class="text-left font-sans text-s md:text-m"
        [ngClass]="{'text-success': minExceeded, 'text-eggplant-100/[0.25]': !minExceeded}">
        <ng-container *ngIf="!minExceeded">
          {{ 'PROJECT_LIST.OBJECTIVE' | translate }} {{ 'PROJECT_LIST.OBJ_MIN' | translate }}: {{ data.total_official |
          number:'1.0-2':'es'}} €
        </ng-container>
        <ng-container *ngIf="minExceeded">
          ✓ {{ 'PROJECT_LIST.OBJ_MIN' | translate }}: {{ data.total_official | number:'1.0-2':'es'}} €
        </ng-container>
      </p>
      <p class="text-right font-sans text-s md:text-m text-eggplant-100/[0.25]">{{ 'PROJECT_LIST.OBJECTIVE' | translate
        }} {{ objetiveParse }} </p>
    </div>
  </div>

  <!-- Desglose comprometido/consolidado en tooltip-->
  <div
    *ngIf="!hiddeLegend && (((data.status === 4 || data.status === 12) && data.contributed > 0) || (data.status === 15 && data.reserved > 0))"
    class="flex gap-16 pt-6 justify-between">
    <div class="flex items-center gap-6" *ngIf="data.currentStage.type !== 3 && percentReserved && percentReserved > 0">
      <span class="w-12 h-12 rounded-full bg-[#FF5C2F]"></span>
      <span class="font-sans text-m text-[#FF5C2F] uppercase">{{ 'OVERVIEW_PROJECT.BAR.LEGEND.INVESTED' | translate }}
        {{ this.percent | number:'1.0-1':'es' }}%</span>
    </div>
    <div class="flex items-center gap-6" *ngIf="data.currentStage.type !== 3 && percentReserved && percentReserved > 0">
      <span class="w-12 h-12 rounded-full bg-[#FFD43C]"></span>
      <span class="font-sans text-m text-[#FFD43C] uppercase">{{ 'OVERVIEW_PROJECT.BAR.LEGEND.RESERVED' | translate }}
        {{ this.percentReserved | number:'1.0-1':'es' }}%</span>
    </div>
  </div>

</div>